"use strict";

const {
  articleId,
  premiumContentType
} = document.currentScript.dataset;

/**
 * Show loader spinner inside piano offer wrap.
 */
document.addEventListener('DOMContentLoaded', () => {
  const pianoOfferWrapper = document.querySelector('#pianoOfferInline');
  const loadingIndicator = document.createElement('div');
  loadingIndicator.setAttribute('class', 'loader offer-loader');
  if (pianoOfferWrapper) {
    pianoOfferWrapper.insertAdjacentElement('beforeend', loadingIndicator);
  }
});

/**
 * If user is subscriber, call unicorn component function that fetches premium
 * data from API service.
 * Pass article Id, User Id and token to generate secret key and fetch data.
 */
const unlockContent = () => {
  const profileData = window.getProfileData();
  const userToken = window.getUserToken();
  const articleContentWrap = document.querySelector('.article__content_wrap');
  if (articleContentWrap) {
    articleContentWrap.classList.remove('is-locked');
    window.Unicorn.call('article-content', 'get_content', articleId, profileData.id, userToken, "");
  } else {
    const path = window.location.pathname;
    const containsEnigmatika = path.indexOf('sudoku') > -1 || path.indexOf('krizaljke') > -1;
    if (containsEnigmatika && window.initIframeOnEnigmatika) window.initIframeOnEnigmatika();
  }
};

/**
 * Listens event triggered by Piano Experience.
 */
document.body.addEventListener('pianoUnlockContent', () => unlockContent(), {
  once: true
});

/**
 * Listens event triggered by other vendors (ie. Google Subscribe)
 */
document.body.addEventListener('meteringUnlockContent', eventData => {
  const userToken = window.getUserToken();
  const profileData = window.getProfileData();
  window.Unicorn.call('article-content', 'get_content', articleId, profileData.id, userToken, eventData.detail.google_metering_key);
}, {
  once: true
});

/**
 * Upon checkout completed,
 * Update `piano_subscription_type to `subscriber`.
 * If `success_url` is passed as GET parameter,
 * opens that url, or else reloads page in order to apply
 * premium ad positions and fetch premium content.
 */
window.tp.push(['addHandler', 'checkoutClose', event => {
  if (event.state === 'checkoutCompleted') {
    const profileData = window.getProfileData();
    profileData.piano_subscription_type = 'subscriber';
    localStorage.setItem('profileData', JSON.stringify(profileData));
    window.showGeneralLoader();
    const successUrl = window.getSuccessUrl();
    if (successUrl) {
      window.open(successUrl, '_self');
    } else {
      window.location.reload();
    }
  }
}]);
document.addEventListener('BaseDataLoaded', async () => {
  /**
   * Push premium content type tag to Piano,
   */
  window.tp.push(['setTags', [premiumContentType]]);
});